import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { IAppPage } from 'src/app/views/layout/layout.component';

@Component({
  selector: 'app-nav-menu-item',
  templateUrl: './nav-menu-item.component.html',
  styleUrls: ['./nav-menu-item.component.scss'],
})
export class NavMenuItemComponent implements OnInit {
  @Input() public appPage: IAppPage;
  @Input() public index = 0;

  @HostBinding('class.expanded')
  @Input()
  public isMenuExpanded: boolean;

  @HostBinding('class.selected')
  get selected() {
    return this.appPage?.isActive ?? false;
  }

  public baseUrl = '';
  public externalEndpoint = false;

  ngOnInit(): void {
    this.externalEndpoint = this.appPage.navigationTo.startsWith('http');
    if (!this.externalEndpoint) {
      this.baseUrl = location.origin + '/';
    }
  }
}
